module.exports = __webpack_public_path__ + "static/img/taft-about.4ade08b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/taft-about.jpg
// module id = 8OrA
// module chunks = 171